<template>
  <div>
  <div :id="uid" class="modal bottom-sheet" style="left: 0">
    <div class="modal-header">
      <a class="modal-close waves-effect waves-green btn-flat"><span class="material-icons">close</span></a>
    </div>
    <div class="modal-content">
      <h6>{{title}}</h6>
      <p v-for="line in lines">{{line}}</p>
    </div>
    
  </div>
  <p :data-target="uid" class="modal-trigger">{{text}}</p>
  </div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
export default {
  data: function () {
    return {
      uid: _.uniqueId("popup")
    }
  },
  created: function(){
  },
  mounted: function(){
    var elemss = this.$el.querySelectorAll('.modal');
    this.instance = M.Modal.init(elemss, {});
  },
  props: { title: {type: String, default: ""}, text: {type: String, default: ""}, lines: {type: Array, default: []}},
  computed: {
   
  },
  
}
</script>
<style scoped>
div {
  margin-left: auto;
  left: auto;
  right: auto;
  line-height: 2;
}
</style>